import React from 'react'

class Cast extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			items: this.props.cast || []
		}
	}

	componentWillReceiveProps(props){
		let cast = props.cast || []

		// Sort by last name.
		cast = cast.sort( (a,b) => {
			if(a.lastname < b.lastname){
				return -1
			}
			if(a.lastname > b.lastname){
				return 1
			}
			return 0
		})

		this.setState({
			items: cast
		})
	}

	render() {
		return (
			<section className="cast">
				{ this.state.items && this.state.items.length ? 
					<div>
						<h3>Cast</h3>
						{/*
						<div className="grid">
							{this.state.items.map( (item, i) => { 
								return (
									<div key={item.id} className="media_container">
										{ item.head_shot ? 
											<img src={decodeURIComponent(item.head_shot)} alt={decodeURIComponent(item.name)} /> :
											<img src="/images/default_avatar.jpg" alt={decodeURIComponent(item.name)} />
										}
										<p><strong>{decodeURIComponent(item.name)}</strong> - {decodeURIComponent(item.part)}</p>
									</div>
								)
							})}
						</div>
						*/}
							{this.state.items.map( item => { 
								return (
									item.part ?
										<div key={item.id} className="media_container"><strong>{decodeURIComponent(item.firstname) + ' ' + decodeURIComponent(item.lastname)}</strong> - {decodeURIComponent(item.part)}</div> :
										<div key={item.id} className="media_container"><strong>{decodeURIComponent(item.firstname) + ' ' + decodeURIComponent(item.lastname)}</strong></div>
								)
							})}
					</div>
					: null
				}
			</section>
		)
	}
}

export default Cast



// WEBPACK FOOTER //
// ./src/components/cast.js